// Chat content row + run-conversation and user-bubble overrides (WEB-8002).
// These MUST compose after the base chat sections — they override them by
// source order (same specificity). Composed by workspaceStyles.ts in place.
export const chatContentRowAndOverrides = `
/* ===== Content row (chat + side panel) ===== */
.ws-content-row {
  display: flex;
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}
.ws-chat-col {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow-x: hidden;
}

/* Extend the date-divider backdrop enough to cover the run-section's extra-wide sticky header
   (which uses calc(100% + 48px)), but not -100vw which causes horizontal scroll in the grid. */
.ai-ws .pr-date-divider::before { left: -48px; right: -48px; }
.ai-ws .pr-prose pre { max-width: 100%; }
.ai-ws .pr-prose table { display: block; overflow-x: auto; max-width: 100%; }

/* ===== Run-based conversation overrides ===== */
.ai-ws .pr-run-bucket-head {
  font-family: var(--ws-sans);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  color: var(--ws-ink-4);
  border-bottom: none;
  padding: 16px 0 6px;
}
.ai-ws .pr-run-bucket-head:not(:first-child) {
  border-top: 1px solid var(--ws-line);
  margin-top: 8px;
  padding-top: 20px;
}
.ai-ws .pr-run-bucket-head:hover { color: var(--ws-ink-3); }
.ai-ws .pr-run-bucket-chev { color: var(--ws-ink-5); }
.ai-ws .pr-run-bucket-count {
  color: var(--ws-ink-5);
  font-weight: 450;
  font-size: 12px;
  letter-spacing: 0;
  text-transform: none;
}
.ai-ws .border-t-2.border-border {
  border-top: none;
  padding-top: 0;
  margin-top: 0;
}
.ai-ws .pr-row-icon {
  color: var(--ws-ink-4);
}
.ai-ws .pr-row-icon svg {
  width: 13px;
  height: 13px;
}
/* Run row sticky header */
.ai-ws .border-t-2.border-border > button {
  font-family: var(--ws-sans);
  border-radius: var(--ws-r-sm);
}
.ai-ws .border-t-2.border-border > button:hover {
  background: var(--ws-hover) !important;
}
.ai-ws .border-t-2.border-border > button .text-body-sm {
  font-family: var(--ws-sans);
  font-size: 13px;
  color: var(--ws-ink-3);
}
.ai-ws .border-t-2.border-border > button .text-grey-7,
.ai-ws .border-t-2.border-border > button .text-grey-8 {
  color: var(--ws-ink-4);
}

/* ===== User bubble override ===== */
.ai-ws .pr-user-bubble {
  background: var(--ws-ink-2);
  color: #c3e8e8;
  border: none;
  border-radius: 18px 18px 4px 18px;
  padding: 12px 18px;
  font-size: 14.5px;
  line-height: 1.5;
}
.ai-ws .pr-user-bubble a {
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
}
.ai-ws .pr-user-bubble a:hover {
  background: rgba(255, 255, 255, 0.24);
}
`;
